import React from 'react';

import styles from './index.module.css';

export default function ClinicalPage({ eyebrow, title, subtitle, children }) {
  return (
    <div className={styles.page}>
      <header className={styles.page_header}>
        <p className={styles.eyebrow}>{eyebrow}</p>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>{subtitle}</p>
      </header>
      <div className={styles.page_body}>{children}</div>
    </div>
  );
}
